export default __webpack_public_path__ + "static/media/banner.3fb06e92.jpeg";